import { render, staticRenderFns } from "./ModulePrecursorSlidebar.vue?vue&type=template&id=91214f5a"
import script from "./ModulePrecursorSlidebar.vue?vue&type=script&lang=js"
export * from "./ModulePrecursorSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports